export const makeOffset = (page, articlePerPage = 10) => {
    return (page - 1) * articlePerPage;
}
export const makePaginationObj = (totalCount, page, articlePerPage, listPerPage = 10) => {
    console.log('makePaginationObj', totalCount, page, articlePerPage, listPerPage);
    const mod = page % listPerPage;
    let totalPage = (totalCount / articlePerPage)
    totalPage += (totalCount % articlePerPage) > 0 ? 1 : 0;

    // idx of in list
    const idxInList = mod > 0 ? mod - 1 : listPerPage - 1;
    const beginPageNum = (Math.ceil(page / listPerPage) - 1) * listPerPage + 1;

    const lastPage = (beginPageNum - 1 + listPerPage);
    const endPageNum = lastPage <= totalPage ? lastPage : totalPage;

    let pageList = [];
    for (let i = beginPageNum; i <= endPageNum; i++) {
        pageList.push(i);
    }

    const prevPageNum = (page > 1 ? page - 1 : 1);
    const nextPageNum = (page < totalPage ? page + 1 : totalPage);

    return {
        firstPageNum: 1,
        prevPageNum,
        idxInList,
        pageList,
        nextPageNum,
        lastPageNum: totalPage
    }
}